import Navbar from "../../../components/Navbar";
import FooterUS from "../USA-Components/FooterUS";

const UsaLayout = ({ children }) => {
  return (
    <div className="w-full flex flex-col min-h-screen">
      <Navbar variant="us" />

      <main className="w-full flex-1 flex flex-col items-center mx-0 mt-20 sm:mt-24 lg:mt-20 p-0">
        {children}
      </main>

      <FooterUS />
    </div>
  );
};

export default UsaLayout;
